import {mapActions, mapMutations} from 'vuex'
import {CONSTANTS} from "@/config/constants";

export default {
  name: 'propertyCard',
  //---components
  props: ['property'],
  //---data
  data () {
    return {
      elevation: 0,
      propertyInfo: {
        isHasTaxReduction: false,
        taxReductionTitle: null,
        isImageLoadSuccess: false,
        isImageLoadError: false,
        isMapImageLoadSuccess: null,
        defaultImg: CONSTANTS.APP_DEFAULT_IMG,
      },
    }
  },
  //---hooks
  created: function () {
    let sellerReport = this.property.sellerReport.data[0] ? this.property.sellerReport.data[0] : null,
      buyerReport = this.property.buyerReport.data[0] ? this.property.buyerReport.data[0] : null;

    let maxValue = 0;

    if (sellerReport && buyerReport) {
      if (sellerReport.isAppealRecommended && buyerReport.isAppealRecommended) {
        maxValue = sellerReport.projectedTaxOverpaymentAmount > buyerReport.projectedTaxOverpaymentAmount ? sellerReport.projectedTaxOverpaymentAmount : buyerReport.projectedTaxOverpaymentAmount;
      } else if (sellerReport.isAppealRecommended && !buyerReport.isAppealRecommended) {
        maxValue = sellerReport.projectedTaxOverpaymentAmount;
      } else if (!sellerReport.isAppealRecommended && buyerReport.isAppealRecommended) {
        maxValue = buyerReport.projectedTaxOverpaymentAmount;
      }
    }

    if (maxValue > 0) {
      this.propertyInfo.taxReductionTitle = 'Up to $' + this.$options.filters.number(maxValue, 0);
      this.propertyInfo.isHasTaxReduction = true;
    }
  },
  computed: {
    getMapImageSrc: function(){
      let fullAddress = this.property.FullStreetAddress + ', ' + this.property.City + ', ' + this.property.StateOrProvince,
        googleFullAddress = fullAddress.replace(/\s/g, '+');

      let baseUrl = 'https://maps.googleapis.com/maps/api/staticmap',
        mapUrl = '?center=' + googleFullAddress + '&zoom=15&scale=false&size=385x95&maptype=roadmap&key=' + process.env.VUE_APP_GOOGLE_API_KEY + '&format=png&visual_refresh=true',
        markerUrl = '&markers=size:small%7Ccolor:0xff0000%7Clabel:%7C' + googleFullAddress;

      return baseUrl + mapUrl + markerUrl;
    },
  },
  //---methods
  methods: {
    ...mapMutations({
      setCurrentPropertyInfo: 'PROPERTY/PROPERTY_INFO_CURRENT_SET'
    }),
    ...mapActions({
      getGeocodingByAddress: 'GOOGLE/GOOGLE_GEOCODING_REQUEST_GET',
    }),
    gotoPropertyInfo(property) {
      this.setCurrentPropertyInfo(property);
      this.$router.push({name: 'property', params: {listing_id: property.id}});
    },
  }
}